import React from 'react';
import PropTypes from 'prop-types';
import {
  NavLink,
} from 'react-router-dom';
import { Typography } from '@leegality/leegality-react-component-library';
import { cn } from '@utils/general';
import { getTranslation } from '@utils';
import { iconRenderer, IconColors } from '@components/icon';

const NavElement = ({
  id, icon, labelKey, link, isChild, keepHidden, onNavigate,
}) => {
  if (keepHidden) return null;
  const baseClass = 'flex items-center p-2 my-1 rounded-md transition-all duration-150 cursor-pointer no-underline hover:bg-primary-50';

  return (
    <NavLink
      to={`${link}`}
      key={id}
      className={({ isActive }) => cn(baseClass, {
        'ml-6': isChild,
        'bg-primary-100': isActive,
      })}
      onClick={() => onNavigate?.()}
    >
      {({ isActive }) => (
        <>
          {icon && iconRenderer({ iconName: icon, size: 16, color: isActive ? IconColors.PRIMARY_LIGHT : IconColors.GRAY })}
          <Typography
            tag={Typography.Tags.SPAN}
            variant={Typography.Variants.sm}
            color={isActive ? Typography.Colors.primary700 : Typography.Colors.gray600}
            className="pl-2"
          >
            {getTranslation(labelKey)}
          </Typography>
        </>
      )}
    </NavLink>
  );
};

NavElement.defaultProps = {
  isChild: false,
  icon: null,
  keepHidden: false,
  onNavigate: null,
};

NavElement.propTypes = {
  id: PropTypes.string.isRequired,
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.elementType, PropTypes.func, PropTypes.oneOf([null])]),
  labelKey: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  isChild: PropTypes.bool,
  keepHidden: PropTypes.bool,
  onNavigate: PropTypes.func,
};

export default NavElement;
